import type { HtmlWidget } from '@inference.engine/widgets';
import type { WidgetDefinition } from '@/entities/widget-definition';

/** The real chat widths: inline beside an open panel and alone, and the panel. */
export const PREVIEW_WIDTHS = { inline: [350, 636], panel: [965] } as const satisfies Record<
  WidgetDefinition['placement'],
  readonly number[]
>;
export type PreviewWidth = 350 | 636 | 965;

// eslint-disable-next-line i18next/no-literal-string -- theme ids, not copy
export const THEMES = ['light', 'dark'] as const;

/** The draft as a chat would show it, filled with one of its samples. */
export function previewWidgetOf(widget: WidgetDefinition, sampleIndex: number): HtmlWidget {
  const draft = widget.draft;
  return {
    document: draft?.document ?? '',
    data: draft?.samples[sampleIndex]?.data ?? {},
    placement: draft?.placement ?? widget.placement,
    runtime: draft?.runtimeHash ?? '',
    title: widget.name,
  };
}
